import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d606cd4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d606cd4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d606cd4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d606cd4c')) {
      api.createRecord('d606cd4c', component.options)
    } else {
      api.reload('d606cd4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d606cd4c&scoped=true", function () {
      api.rerender('d606cd4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/page/index.vue"
export default component.exports